import React from 'react';
import { usePageSeo } from "../../shared/seo";

const AboutUs = () => {
  usePageSeo("about");

  return (
    <div>
      <h2>About Fugu's</h2>
      <p>Your trusted source for fresh fish and seafood since 2020.</p>
      <p>We provide the highest quality seafood directly from local fishermen to your table.</p>
      <p>Our commitment to freshness and sustainability makes us the preferred choice for seafood lovers.</p>
    </div>
  );
};

export default AboutUs;
